<script>
import StatsDataService from "@/services/StatsDataService";

export default {
  name: "ChartUsersVideos",
  data() {
    return {
      results: {
        woman: {
          total: 0,
          photos: 0,
          videos: 0,
          photos_perc: 0,
          videos_perc: 0
        },
        man: {
          total: 0,
          photos: 0,
          videos: 0,
          photos_perc: 0,
          videos_perc: 0
        },
      },
      filtersDates: {
        selected: '1M',
        options: [
          {value:'T', text:'T.'},
          {value:'Y', text:'Y.'},
          {value:'1W', text:'1W'},
          {value:'1M', text:'1M'},
          {value:'3M', text:'3M'},
          {value:'6M', text:'6M'},
          {value:'1Y', text:'1Y'},
          {value:'ALL', text:'ALL'},
        ]
      }
    }
  },
  methods: {
    handleDateChange() {
      this.loadData();
    },

    loadData() {
      const params = {date: this.filtersDates.selected};
      StatsDataService.getUsersVideosStats(params)
          .then(response => {
            this.results = response.data;
          })
          .catch(error => {
            window.console.error("StatsDataService.getUsersAgeStats failed...", error);
          });
    }
  },
  mounted() {
    this.loadData();
  }
}
</script>

<template>
  <div class="card-body" id="cardUsersVideos">
      <h5 class="card-title">Gender Media</h5>
      <b-form-radio-group
          v-model="filtersDates.selected"
          :options="filtersDates.options"
          button-variant="outline-secondary"
          size="sm"
          buttons
          class="mt-1 mb-2"
          @change="handleDateChange"
      ></b-form-radio-group>

    <div class="table-responsive mt-4">
        <div class="text-center">
          <h3>Men</h3>
          <p><b>Total: </b>{{ results.man.total }}</p>
        </div>
        <table class="table table-centered">
          <tbody>
          <tr>
            <td style="width: 140px">
              <p class="mb-0">Pictures</p>
            </td>
            <td style="width: 120px">
              <h5 class="mb-0">{{ results.man.photos }} <span class="text-secondary font-size-12">{{ results.man.photos_perc }}%</span></h5>
            </td>
            <td>
              <b-progress
                  :value="results.man.photos_perc"
                  variant="primary"
                  height="5px"
              ></b-progress>
            </td>
          </tr>
          <tr>
            <td style="width: 140px">
              <p class="mb-0">Videos</p>
            </td>
            <td style="width: 120px">
              <h5 class="mb-0">{{ results.man.videos }} <span class="text-secondary font-size-12">{{ results.man.videos_perc }}%</span></h5>
            </td>
            <td>
              <b-progress
                  :value="results.man.videos_perc"
                  variant="primary"
                  height="5px"
              ></b-progress>
            </td>
          </tr>
          </tbody>
        </table>

        <div class="text-center">
          <h3>Women</h3>
          <p><b>Total: </b>{{ results.woman.total }}</p>
        </div>
        <table class="table table-centered">
          <tbody>
          <tr>
            <td style="width: 140px">
              <p class="mb-0">Pictures</p>
            </td>
            <td style="width: 120px">
              <h5 class="mb-0">{{ results.woman.photos }} <span class="text-secondary font-size-12">{{ results.woman.photos_perc }}%</span></h5>
            </td>
            <td>
              <b-progress
                  :value="results.woman.photos_perc"
                  variant="primary"
                  height="5px"
              ></b-progress>
            </td>
          </tr>
          <tr>
            <td style="width: 140px">
              <p class="mb-0">Videos</p>
            </td>
            <td style="width: 120px">
              <h5 class="mb-0">{{ results.woman.videos }} <span class="text-secondary font-size-12">{{ results.woman.videos_perc }}%</span></h5>
            </td>
            <td>
              <b-progress
                  :value="results.woman.videos_perc"
                  variant="primary"
                  height="5px"
              ></b-progress>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

  </div>
</template>

<style>
#cardUsersVideos .btn input[type=radio] {
  position: absolute;
  clip: rect(0,0,0,0);
  pointer-events: none;
}

#cardUsersVideos .btn {
  margin-top: -8px;
  margin-bottom: 0 !important;
}
</style>